import {Injectable} from '@angular/core';
import {AuthToken, SerializeUtil} from "../models/models";
import {User} from "../../user/models/user.model";

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private readonly AUTH_TOKEN_PREFIX = 'auth_';
  private readonly INTERNAL_USER_PREFIX = 'internal_user_';

  constructor() {
  }

  public getAuthToken(): AuthToken | null {
    return this.getObject(new AuthToken(), this.AUTH_TOKEN_PREFIX);
  }

  public setAuthToken(authToken: AuthToken): void {
    this.setObject(authToken, this.AUTH_TOKEN_PREFIX);
  }

  public setInternalUser(internalUser: User): void {
    this.setItem(`${this.INTERNAL_USER_PREFIX}id`, internalUser.id);
    this.setItem(`${this.INTERNAL_USER_PREFIX}first_name`, internalUser.first_name);
    this.setItem(`${this.INTERNAL_USER_PREFIX}last_name`, internalUser.last_name);
  }

  public getInternalUserId(): number {
    return this.getItem(`${this.INTERNAL_USER_PREFIX}id`);
  }

  public getInternalUserFirstName(): string {
    return this.getItem(`${this.INTERNAL_USER_PREFIX}first_name`);
  }

  public getInternalUserLastName(): string {
    return this.getItem(`${this.INTERNAL_USER_PREFIX}last_name`);
  }

  public deleteAuthToken(): void {
    Object.keys(new AuthToken()).forEach(key => this.removeItem(key));
  }

  public deleteInternalUser(): void {
    this.removeItem(`${this.INTERNAL_USER_PREFIX}id`);
    this.removeItem(`${this.INTERNAL_USER_PREFIX}first_name`);
    this.removeItem(`${this.INTERNAL_USER_PREFIX}last_name`);
  }

  public getObject(object: { [key: string]: any }, prefix: string): any | null {
    const cookieObj: { [key: string]: string } = {}
    Object.keys(object).forEach(key => {
      cookieObj[key] = this.getItem(prefix + key)
    });
    if (cookieObj['id']) {
      return SerializeUtil.deserialize(object, cookieObj);
    }
    return null;
  }

  public setObject(object: { [key: string]: any }, prefix: string): void {
    Object.entries(object).forEach(([key, value]) => this.setItem(prefix + key, value));
  }


  public setItem(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  public getItem(key: string): any {
    const item = localStorage.getItem(key);
    if (item) {
      return JSON.parse(item);
    }
    return item;
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public clear() {
    localStorage.clear();
  }
}
